export function getTreatmentStatuses(treatment_statuses) {
  return treatment_statuses.map(status => ({
    id: status.type,
    text: status.name,
  }))
}
